var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurpriseBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.67907 15.895a9.99224 9.99224 0 0 0 -4.45911 4.544.20168.20168 0 0 1 -.35176.00332 9.99222 9.99222 0 0 0 -4.544-4.45912.20168.20168 0 0 1 -.00331-.35176 9.9922 9.9922 0 0 0 4.45911-4.544.20168.20168 0 0 1 .35176-.00331 9.99231 9.99231 0 0 0 4.544 4.45912.20167.20167 0 0 1 .00331.35175z",
    fill: "#85b0f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.19747 15.4662a7.96014 7.96014 0 0 0 -1.91977 4.5893.20181.20181 0 0 1 -.325.13329 7.96019 7.96019 0 0 0 -4.5893-1.91979.20181.20181 0 0 1 -.13329-.325 7.96022 7.96022 0 0 0 1.91976-4.5893.20182.20182 0 0 1 .325-.1333 7.96017 7.96017 0 0 0 4.5893 1.91977.20182.20182 0 0 1 .1333.32503z",
    fill: "#85b0f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32 30-19 4 19 4 19-4z",
    fill: "#ccad65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m32 30v8l19-4z",
    fill: "#bfa25f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33.63064 22h-3.26088v-7.8362a1.61812 1.61812 0 0 1 1.63044-1.60535 4.17438 4.17438 0 1 0 -4.23931-4.17368h-3.26089a7.5009 7.5009 0 0 1 15 0 7.42466 7.42466 0 0 1 -5.86936 7.2088z",
    fill: "#d98282"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#d98282",
    r: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32 38v25l-20-6v-22l1-1z",
    fill: "#d9a641"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m51 34-19 4v25l20-6v-22z",
    fill: "#e6b045"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m13 34 19 4-5 7-20-5z",
    fill: "#d9b978"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m51 34-19 4 5 7 20-5z",
    fill: "#e6c47f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a3b9d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.76388 29.24892-1.46777-.308a15.08384 15.08384 0 0 1 8.95889-10.84567l.58272 1.38187a13.58491 13.58491 0 0 0 -8.07384 9.7718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.35463 29.08485a13.59772 13.59772 0 0 0 -10.501-9.25439l.27735-1.47461a15.1016 15.1016 0 0 1 11.65234 10.271z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurpriseBox);
export default __webpack_public_path__ + "static/media/surprise-box.a55d91db20003f3468e91abc9803470d.svg";
export { ForwardRef as ReactComponent };